export default function fetchHelper(url, options) {
    const country = document.documentElement.getAttribute('country') || 'gb';
    const langauge = document.documentElement.getAttribute('lang') || 'en';
    const opts = options ?? {};
    opts.headers = {
        ...(opts.headers ? opts.headers : {}),
        'X-Country': country,
        'X-Language': langauge,
    };
    return fetch(url, opts);
}
